<template>
  <v-container class="neat-container">
    <div class="d-flex flex-row justify-content-between">
      <div class="my-auto ml-0">
        <v-row no-gutters>
          <small class="detail">
            {{ licensePlateNumber }}
          </small>
          <CopyButton v-if="licensePlateNumber.length != 0" class="ml-1" :text="licensePlateNumber" />
        </v-row>
        <v-row no-gutters>
          <small class="detail">{{ vin }}</small>
          <CopyButton v-if="vin.length != 0" class="ml-1" :text="vin" />
        </v-row>
      </div>
      <div class="my-auto mr-0">
        <v-btn class="btn-sm mr-2" :width="45" :height="40" color="#d9753b" :fab="true" @click="startPartsExtractionProcess(carId)" dark>
          <v-icon>mdi-car-door</v-icon>
        </v-btn>
        <router-link :to="{ name: 'cardetails', params: { id: carId } }">
          <v-btn class="btn-sm" :width="45" :height="40" color="#033e8c" :fab="true" dark>
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </router-link>
         
      </div>
    </div>
    <v-card class="mt-1 img-container" outlined>
      <v-progress-circular
        v-if="isLoading"
        :size="50"
        :width="5"
        color="#033e8c"
        indeterminate
      ></v-progress-circular>
      <img v-if="!isLoading && img" :src="img" class="car-img" alt="Car Picture" />
    </v-card>
    <hr class="separator my-3 py-0" />
  </v-container>
</template>

<script>
import CopyButton from '@/components/common/CopyButton.vue';
import { DOCUMENT_TYPE_CAR_PICTURE } from "@/constants"

export default {
  name: "CarInfo",
  components: {
    CopyButton
  },
  props: {
    carId: {
      type: Number,
      default: -1
    },
    licensePlateNumber: {
      type: String,
      default: ''
    },
    vin: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      img: '',
      documentType: DOCUMENT_TYPE_CAR_PICTURE,
      isLoading: false,
    }
  },
  computed: {
    buttonWidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '7.5rem'
        default: return '8rem'
      }
    }
  },
   methods: {
    startPartsExtractionProcess(carId) {
      /* td 202009032320 #105 added starting processes by hardcoded name and variables */
      let variables={variables:{car_id:{value: carId,type: "Integer"}}}
      console.log ('startPartsExtractionProcess', variables);
      this.$store.dispatch('startBPMProcess', ['PartsExtraction', variables]) /* #105 add parameters to the method*/
      .then(response => {
        console.log("New process instance ID:", response)
      })
      .catch(error => {
        console.log("Cannot start new process:", error)
        this.$store.dispatch('showNotification', {
          text: 'errorWhileStartingProcess',
          interval: 4000})
      })
    },
   },
  created() {
    this.isLoading = true
    this.axios.get(`/Documents/get?document_type_id=${this.documentType}&data_id=${this.carId}`)
    .then(response => {
      if ('data' in response.data && response.data.data.length > 0) {
        this.img = response.data.data[0]?.data_doc_raw
      }
    })
    .catch(error => {
      console.log('Failed retrieving car picture', error)
    })
    .finally(() => {
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
.detail {
  display: inline-flex;
  align-items: center;
  font-size: 0.9375rem;
  color: #2d2d2d;
  margin-bottom: 0;
}

.btn-sm {
  /* width: 7.5rem; */
  height: 100%;
  font-size: 0.9375rem;
  font-weight: 500;
}

.img-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 204px;
  width: auto;
  overflow: hidden;
  background-color: rgb(215, 215, 215);
}

.car-img {
  height: 202px;
  width: auto;
}

</style>